import React from 'react';
import { Eye, Share2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { generateLoadShareableLink } from '../utils/loadUtils';

export const LoadActionButtons = ({ 
  load, 
  isMobile, 
  canShare = false,
  viewButtonText = 'Full Details',
  viewButtonIcon: ViewIcon = Eye,
  className = ''
}) => {
  const navigate = useNavigate();

  const handleShare = async (e) => {
    e.stopPropagation();
    const shareableLink = generateLoadShareableLink(load.id);
    const shareData = {
      title: `Load #${load.id} - ${load.origin_city} to ${load.destination_city}`,
      text: `Freight load from ${load.origin_city}, ${load.origin_state} to ${load.destination_city}, ${load.destination_state}`,
      url: shareableLink
    };

    try {
      if (navigator.share && navigator.canShare(shareData)) {
        await navigator.share(shareData);
        toast.success('Load details shared successfully!');
      } else {
        await navigator.clipboard.writeText(shareableLink);
        toast.success('Link copied to clipboard!');
      }
    } catch (err) {
      console.error('Error sharing load:', err);
      toast.error('Unable to share load details. Please try again.');
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <motion.button
        onClick={() => navigate(`/loads/${load.id}`)}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        className={`
          inline-flex items-center px-4 py-2 rounded-lg
          bg-gradient-to-r from-blue-500 to-blue-600
          text-white font-medium text-sm
          shadow-sm hover:shadow-md
          transition-all duration-200
          flex-1 justify-center
        `}
      >
        <ViewIcon className="w-4 h-4 mr-2" />
        {isMobile ? 'Full Details' : viewButtonText}
      </motion.button>

      {canShare && (
        <motion.button
          onClick={handleShare}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className={`
            inline-flex items-center px-4 py-2 rounded-lg
            bg-gray-50 text-gray-700 
            border border-gray-200
            font-medium text-sm
            shadow-sm hover:shadow-md hover:bg-gray-100
            transition-all duration-200
            ${isMobile ? 'flex-1 justify-center' : ''}
          `}
        >
          <Share2 className="w-4 h-4" />
          <span className={isMobile ? 'ml-2' : 'ml-2'}>
            {isMobile ? 'Share' : 'Share'}
          </span>
        </motion.button>
      )}
    </div>
  );
}; 